import { render, staticRenderFns } from "./EnrollmentStatus.vue?vue&type=template&id=0c7da0a4"
import script from "./EnrollmentStatus.vue?vue&type=script&lang=js"
export * from "./EnrollmentStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports